

import React, { useEffect, useState, useMemo } from "react";
import {useNavigate, useParams} from "react-router-dom";
import { apiFetch } from "../../api/api";
import BreadCrumb from "Common/BreadCrumb";
import { Loader2 } from "lucide-react";


type QuestionMap = Record<number, string>;

type AnswerItem = {
    QID: number;
    QuestionTitle: string;
    AnswerIDs: string;
    AnswerTitles: string;
    Responder: string;
};

type SurveyResultRow = {
    SentID: number;
    FID: number;
    SentDate: string;
    answers: AnswerItem[];
};

const SurveyResults = () => {
    const { form_id } = useParams<{ form_id: string }>();
    const navigate = useNavigate();

    const [results, setResults] = useState<SurveyResultRow[]>([]);
    const [questionsMap, setQuestionsMap] = useState<QuestionMap>({});
    const [loading, setLoading] = useState(false);

    const fetchAllQuestions = async () => {
        const res = await apiFetch({
            data: { params: [Number(form_id), 0, 0, 0, 4, 5,null] },
        });

        if (res.success && Array.isArray(res.result)) {
            const map: QuestionMap = {};
            res.result.forEach((q: any) => {
                map[q.QID] = q.Title;
            });
            setQuestionsMap(map);
        }
    };

    const fetchResults = async () => {
        setLoading(true);

        try {
            const res = await apiFetch({
                data: { params: [Number(form_id), 0, 0, 0, 4, 5, null] },
            });

            if (res.success && Array.isArray(res.rows)) {
                const parsed: SurveyResultRow[] = res.rows.map((row: any) => ({
                    SentID: Number(row.SentID),
                    FID: Number(row.FID),
                    SentDate: row.SentDate,
                    answers: JSON.parse(row.answers || "[]"),
                }));

                setResults(parsed);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllQuestions();
        fetchResults();
    }, [form_id]);

    // // استخراج تمام سوال‌ها
    // const allQuestions = useMemo(() => {
    //     const ids = new Set<number>();
    //
    //     results.forEach((r) =>
    //         r.answers.forEach((a) => ids.add(a.QID))
    //     );
    //
    //     return Array.from(ids).sort((a, b) => a - b);
    // }, [results]);

    const allQuestions = useMemo(() => {
        const map = new Map<number, string>();

        results.forEach((r) => {
            r.answers.forEach((a) => {
                if (!map.has(a.QID)) {
                    map.set(a.QID, a.QuestionTitle);
                }
            });
        });

        return Array.from(map.entries());
    }, [results]);

    return (
        <>
            <BreadCrumb title="نتایج نظرسنجی" pageTitle="Survey Results" />

            <button
                onClick={() => navigate(`/forms/${form_id}`)}
                className="flex items-center gap-2 bg-custom-500 text-white px-5 py-2 rounded-xl hover:bg-custom-600 transition-all shadow-sm"
            >
                بازگشت
            </button>
            <div className="w-11/12 mx-auto mt-8 bg-white dark:bg-zink-800 rounded-lg p-6 shadow">

                {loading ? (
                    <div className="flex justify-center items-center py-10 text-slate-500">
                        <Loader2 className="animate-spin mr-2" />
                        در حال بارگذاری...
                    </div>
                ) : (
                    <div className="overflow-x-auto">

                        <table className="w-full text-sm border border-slate-200 dark:border-zink-700">

                            <thead className="bg-slate-100 dark:bg-zink-700">
                            <tr>
                                <th className="p-3 border">#</th>

                                {allQuestions.map(([qid,title]) => (
                                    <th key={qid} className="p-3 border min-w-[200px]">
                                        {/*{questionsMap[qid] || `سوال ${qid}`}*/}
                                        {title}
                                    </th>
                                ))}
                            </tr>
                            </thead>

                            <tbody>
                            {results.map((row) => (
                                <tr
                                    key={row.SentID}
                                    className="hover:bg-slate-50 dark:hover:bg-zink-700"
                                >
                                    <td className="p-3 border text-center">{row.SentID}</td>

                                    {allQuestions.map(([qid,title]) => {
                                        const ans = row.answers.find((a) => a.QID === qid);

                                        return (
                                            <td key={qid} className="p-3 border text-center">
                                                {ans ? ans.AnswerTitles : "-"}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                            </tbody>

                        </table>

                    </div>
                )}
            </div>
        </>
    );
};

export default SurveyResults;
